import is from '@sindresorhus/is';
import type { ChangeEvent, FunctionComponent } from 'react';
import { Fragment } from 'react';
import Maybe from 'true-myth/maybe';

import { PrimaryButton } from './components/PrimaryButton';
import { StepHeader } from './components/StepHeader';
import { TextArea } from './components/TextArea';
import { useCompanyOnboardingStore } from './use-company-onboarding-store';

export const CompanyIntroductionStep: FunctionComponent = () => {
    const companyDescription = useCompanyOnboardingStore((state) => state.companyDescription);
    const setCompanyDescription = useCompanyOnboardingStore((state) => state.setCompanyDescription);
    const updateCompanyDescription = useCompanyOnboardingStore((state) => state.updateCompanyDescription);
    const isGeneratingCompanyDescription = useCompanyOnboardingStore((state) => state.isGeneratingCompanyDescription);

    const companyProfileIntroductionLabel = useCompanyOnboardingStore((state) => state.companyProfileIntroductionLabel);
    const companyProfileIntroductionDescriptionLabel = useCompanyOnboardingStore(
        (state) => state.companyProfileIntroductionDescriptionLabel,
    );
    const descriptionLabel = useCompanyOnboardingStore((state) => state.descriptionLabel);
    const continueLabel = useCompanyOnboardingStore((state) => state.continueLabel);

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
        const data: Maybe<string> = is.emptyString(event.target.value)
            ? Maybe.nothing()
            : Maybe.just(event.target.value);

        setCompanyDescription(data);
    };

    return (
        <Fragment>
            <StepHeader
                headlineText={companyProfileIntroductionLabel}
                subHeadlineText={companyProfileIntroductionDescriptionLabel}
            />
            <TextArea
                isGenerating={isGeneratingCompanyDescription}
                text={companyDescription.unwrapOr('')}
                title={descriptionLabel}
                onChange={handleChange}
            />
            {isGeneratingCompanyDescription ? null : (
                <PrimaryButton disabled={companyDescription.isNothing} onClick={updateCompanyDescription}>
                    {continueLabel}
                </PrimaryButton>
            )}
        </Fragment>
    );
};
